import SliderInquiry from './component'
export { SliderInquiry }
export default SliderInquiry